/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './operation-theatre-equipment.reducer';

export const OperationTheatreEquipmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const operationTheatreEquipmentEntity = useAppSelector(state => state.operationTheatreEquipment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="operationTheatreEquipmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.detail.title">OperationTheatreEquipment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.id">Id</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.active">Active</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEquipmentEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.theatre">Theatre</Translate>
          </dt>
          <dd>{operationTheatreEquipmentEntity.theatre ? operationTheatreEquipmentEntity.theatre.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.equipment">Equipment</Translate>
          </dt>
          <dd>{operationTheatreEquipmentEntity.equipment ? operationTheatreEquipmentEntity.equipment.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/operation-theatre-equipment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/operation-theatre-equipment/${operationTheatreEquipmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OperationTheatreEquipmentDetail;
